import React from 'react'
import { useContext } from 'react'
import { CandidatesContext } from '../../../utils/context'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getCandidateParents, saveCandidateParents } from '../../../actions/candidates'
import { getCountries, getSubjects } from '../../../actions/common'
import styles from './styles.module.scss'
import Button from '../../../components/Button'
import { Input, Select } from '../../../components/ModalInputs'
import { useFormik } from 'formik'
import { armyClasses, armyDistricts, docTypes, MILITARY_RANKS } from '../../../assets/const'


// Специфичные имена полей для каждого участника
const PERSON_FIELDS = {
  mother: {
    prefix:          'mother',
    phoneMobile:     'tel_mobile2',
    phoneWork:       'tel_work2',
    workplace:       'mother_work',
    district:        'mother_military_district',
    arm:             'mother_arm',
    unitNumber:      'mother_military_number',
    rank:            'mother_military_rank',
    position:        'mother_military_pos',
    serviceLong:     'mother_military_long',
    concessionLong:  'mother_military_concession_long',
    docType:         'motherdocumenttype',
    docSeria:        'motherdocumentseria',
    docNumber:       'motherdocumentnumber',
    docWhengive:     'motherdocumentwhengive',
    docWhogive:      'motherdocumentwhogive',
  },
  father: {
    prefix:          'father',
    phoneMobile:     'tel_mobile',
    phoneWork:       'tel_work',
    workplace:       'father_work',
    district:        'father_military_district',
    arm:             'father_arm',
    unitNumber:      'father_military_number',
    rank:            'father_military_rank',
    position:        'father_military_pos',
    serviceLong:     'father_military_long',
    concessionLong:  'father_military_concession_long',
    docType:         'fatherdocumenttype',
    docSeria:        'fatherdocumentseria',
    docNumber:       'fatherdocumentnumber',
    docWhengive:     'fatherdocumentwhengive',
    docWhogive:      'fatherdocumentwhogive',
  },
  trustee: {
    prefix:          'trustee',
    phoneMobile:     'trustee_phone',
    phoneWork:       'tel_work3',
    workplace:       'trustee_work',
    district:        'trustee_military_district',
    arm:             'trustee_arm',
    unitNumber:      'trustee_military_number',
    rank:            'trustee_military_rank',
    position:        'trustee_military_pos',
    serviceLong:     'trustee_military_long',
    concessionLong:  'trustee_military_concession_long',
    docType:         'trusteedocumenttype',
    docSeria:        'trusteedocumentseria',
    docNumber:       'trusteedocumentnumber',
    docWhengive:     'trusteedocumentwhengive',
    docWhogive:      'trusteedocumentwhogive',
  },
  trustee2: {
    prefix:          'trustee2',
    phoneMobile:     'trustee2_phone',
    phoneWork:       'tel_work4',
    workplace:       'trustee2_work',
    district:        'trustee2_military_district',
    arm:             'trustee2_arm',
    unitNumber:      'trustee2_military_number',
    rank:            'trustee2_military_rank',
    position:        'trustee2_military_pos',
    serviceLong:     'trustee2_military_long',
    concessionLong:  'trustee2_military_concession_long',
    docType:         'trustee2documenttype',
    docSeria:        'trustee2documentseria',
    docNumber:       'trustee2documentnumber',
    docWhengive:     'trustee2documentwhengive',
    docWhogive:      'trustee2documentwhogive',
  },
}


export default function Parents() {

  const { candidateId, closeModal } = useContext(CandidatesContext)
  const dispatch = useDispatch()
  const { parents: data } = useSelector(state => state.candidates.data)
  const { subjects, countries } = useSelector(state => state.common)

  useEffect(() => {
    candidateId !== 'add' && dispatch(getCandidateParents(candidateId))
    !subjects && dispatch(getSubjects())
    !countries && dispatch(getCountries())
  }, [])

  const { values, handleChange, handleSubmit } = useFormik({
    initialValues: data || {},
    enableReinitialize: true,
    onSubmit: (formData) => {
      dispatch(saveCandidateParents(candidateId, formData))
    }
  })

  const v = (name) => values[name] || ''

  const renderCountryOptions    = () => countries?.map(({ xp_key, name }) => <option key={xp_key} value={xp_key}>{name}</option>)
  const renderSubjectOptions    = () => subjects?.map(({ idsubject, subject }) => <option key={idsubject} value={idsubject}>{subject}</option>)
  const renderDistrictOptions   = () => armyDistricts.map(({ name, value }) => <option key={value} value={value}>{name}</option>)
  const renderArmyClassOptions  = () => armyClasses.map(({ name, value }) => <option key={value} value={value}>{name}</option>)
  const renderRankOptions       = () => MILITARY_RANKS?.map((rank, idx) => <option key={idx} value={rank}>{rank}</option>)
  const renderDocTypeOptions    = () => docTypes.map(({ name, value }) => <option key={value} value={value}>{name}</option>)

  const ParentSection = ({ title, person }) => {
    const f = PERSON_FIELDS[person]
    const p = f.prefix
    return (
      <>
        <h5>{title}</h5>
        <div className={styles.inputsRow}>
          <Input label='Фамилия'  name={`${p}_lastname`}  value={v(`${p}_lastname`)}  onChange={handleChange} />
          <Input label='Имя'      name={`${p}_firstname`} value={v(`${p}_firstname`)} onChange={handleChange} />
          <Input label='Отчество' name={`${p}_midname`}   value={v(`${p}_midname`)}   onChange={handleChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input label='Телефон мобильный' name={f.phoneMobile} value={v(f.phoneMobile)} onChange={handleChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input label='Место службы/работы' name={f.workplace}  value={v(f.workplace)}  onChange={handleChange} />
          <Input label='Телефон служебный'   name={f.phoneWork}  value={v(f.phoneWork)}  onChange={handleChange} />
        </div>
        <div className={styles.inputsRow}>
          <Select label='Страна'     name={`${p}_country`} value={v(`${p}_country`)} onChange={handleChange}>{renderCountryOptions()}</Select>
          <Select label='Субъект РФ' name={`${p}_subject`} value={v(`${p}_subject`)} onChange={handleChange}>{renderSubjectOptions()}</Select>
        </div>
        <div className={styles.inputsRow}>
          <Select label='Военный округ' name={f.district}  value={v(f.district)}  onChange={handleChange}>{renderDistrictOptions()}</Select>
          <Select label='Вид, род войск' name={f.arm}      value={v(f.arm)}       onChange={handleChange}>{renderArmyClassOptions()}</Select>
          <Input  label='Номер в/ч'      name={f.unitNumber} value={v(f.unitNumber)} onChange={handleChange} />
        </div>
        <div className={styles.inputsRow}>
          <Select label='Звание'    name={f.rank}     value={v(f.rank)}     onChange={handleChange}>{renderRankOptions()}</Select>
          <Input  label='Должность' name={f.position} value={v(f.position)} onChange={handleChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input label='Выслуга лет, мес.'          name={f.serviceLong}    value={v(f.serviceLong)}    onChange={handleChange} />
          <Input label='Льготная выслуга лет, мес.' name={f.concessionLong} value={v(f.concessionLong)} onChange={handleChange} />
        </div>
        <div className={styles.inputsRow}>
          <Select label='Тип документа' name={f.docType}  value={v(f.docType)}  onChange={handleChange}>{renderDocTypeOptions()}</Select>
          <Input  label='Серия'         name={f.docSeria}  value={v(f.docSeria)}  onChange={handleChange} />
          <Input  label='Номер'         name={f.docNumber} value={v(f.docNumber)} onChange={handleChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input type='date' label='Когда выдан' name={f.docWhengive} value={v(f.docWhengive)} onChange={handleChange} />
          <Input label='Кем выдан'               name={f.docWhogive}  value={v(f.docWhogive)}  onChange={handleChange} />
        </div>
      </>
    )
  }

  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsRow}>
            <Select label='Законные представители для связи' name='mail_list' value={v('mail_list')} onChange={handleChange}>
              <option value='1'>Мать</option>
              <option value='2'>Отец</option>
              <option value='3'>Опекун</option>
              <option value='4'>Опекун 2</option>
            </Select>
            <Input label='Телефон для уведомлений' name='notificationphone' value={v('notificationphone')} onChange={handleChange} />
          </div>
          <div className={styles.inputsRow}>
            <Input label='Телефон домашний' name='tel_home' value={v('tel_home')} onChange={handleChange} />
            <Input label='E-mail'           name='email'    value={v('email')}    onChange={handleChange} />
          </div>

          <ParentSection title='Мать'     person='mother'  />
          <ParentSection title='Отец'     person='father'  />
          <ParentSection title='Опекун'   person='trustee' />
          <ParentSection title='Опекун 2' person='trustee2' />
        </div>
      </div>
      <div className={styles.modalFooter}>
        <div>
          <div>Создал: </div>
          <div>Изменил: </div>
        </div>
        <Button mode='white' onClick={handleSubmit}>Сохранить</Button>
        <Button mode='white' onClick={closeModal}>Закрыть</Button>
      </div>
    </>
  )
}
